import { useKeycloak } from "@react-keycloak/web";
import { Button, Card, Input, TableProps, Tooltip } from "antd";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../../app/store";
import AddIcon from "../../../assets/icons/AddIcon";
import EditIcon from "../../../assets/icons/EditIcon";
import InsideWalletIcon from "../../../assets/icons/InsideWalletIcon";
import SearchIcon from "../../../assets/icons/SearchIcon";
import UserIcon from "../../../assets/icons/UserIcon";
import WalletBalanceChecker from "../../../components/common/WalletBalanceChecker";
import CustomTable from "../../../components/ui/CustomTable";
import {
  useGetAllWalletQuery,
  useGetSingleCompanyQuery,
} from "../../../features/portal/companyOnboard/companyOnboardApi";
import useError from "../../../hooks/useError";
import useModal from "../../../hooks/useModal";
import useTable from "../../../hooks/useTable";
import SidebarLayout from "../../../layouts/SidebarLayout";
import {
  GetAllWalletParamsType,
  GetAllWalletTagDataType,
} from "../../../types/portal/companyOnboard";
import { countParPageSerialNumber } from "../../../utils/number";
import { capitalize } from "../../../utils/string";
import { addKeyInArray } from "../../../utils/utils";
import AddWalletModal from "./AddWalletModal";

export default function ShebaPayWallet() {
  const { open, handleOpen, handleClose } = useModal();
  const [paymentStatus, setPayentStatus] = useState("true");
  const [isActive, setIsActive] = useState(true);
  const [selectedWallet, setSelectedWallet] = useState<string | null>(null);
  const {
    page,
    limit,
    handlePagination,
    handleFilter,
    handleLimit,
    filter,
    keyword,
    handleSearch,
  } = useTable<GetAllWalletParamsType>();
  // const navigate = useNavigate();

  const { keycloak } = useKeycloak();
  const { user } = useAppSelector((state) => state.auth);
  const {
    isLoading: isCompanyDetailsLoading,
    isError: isCompanyDetailsError,
    error: companyDetailsError,
    data: companyDetails,
  } = useGetSingleCompanyQuery(user?.data?.company_id, {
    skip: !user?.data?.company_id,
  });

  // const {
  //   isLoading: isBalanceCheckLoading,
  //   isError: isBalanceCheckError,
  //   error: balanceCheckError,
  //   data: balanceCheck,
  // } = useBalanceCheckQuery(
  //   {
  //     walletNumber: selectedWallet || "",
  //     companyId: user?.data?.company_id,
  //   },
  //   {
  //     // skip: !companyDetails?.data?.wallet_number || !user?.data?.company_id,
  //     skip: !selectedWallet || !user?.data?.company_id,
  //   }
  // );

  const {
    data: getAllWalletData,
    isError: getAllWalletIsError,
    error: getAllWalletError,
    isLoading: getAllWalletIsLoading,
  } = useGetAllWalletQuery({
    params: {
      search: keyword,
      page,
      limit,
    },
  });

  useError(isCompanyDetailsError, companyDetailsError, "Get company data fail");
  // useError(isBalanceCheckError, balanceCheckError, "Get balance data fail");
  useError(getAllWalletIsError, getAllWalletError, "Get wallet data fail");

  const roleCheck = localStorage.getItem("project_role");

  const isAdmin =
    keycloak?.realmAccess?.roles?.includes("admin") ||
    keycloak?.realmAccess?.roles?.includes("admin2");

  const leaveSettingsTabList = [
    {
      label: "Wallets",
      link: `/admin/sheba-pay-wallet`,
    },
    // {
    //   label: "Tags",
    //   link: `/admin/sheba-pay-wallet/wallet-tags`,
    // },
  ];

  const columns: TableProps<GetAllWalletTagDataType>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: "Wallet Name",
      dataIndex: "wallet_name",
      render: (val) => (val ? capitalize(val) : "N/A"),
    },
    {
      title: "Source Wallet",
      dataIndex: "wallet_number",
      align: "center",
      render: (val) => (val ? val : "N/A"),
    },
    // {
    //   title: "Wallet Tag",
    //   dataIndex: "tags",
    //   align: "left",
    //   render: (tags: { id: number; name: string }[]) => (
    //     <div className="flex flex-wrap justify-start gap-1">
    //       {tags && tags.length > 0 ? (
    //         tags.map((tag) => (
    //           <div
    //             key={tag.id}
    //             className="px-2 py-0.5 bg-slate-100 rounded-md inline-flex justify-start items-center gap-1.5"
    //           >
    //             <div className="text-slate-700 text-xs font-normal">
    //               {tag.name}
    //             </div>
    //           </div>
    //         ))
    //       ) : (
    //         <div className="text-gray-400 text-xs">N/A</div>
    //       )}
    //     </div>
    //   ),
    // },

    {
      title: "Wallet Balance",
      dataIndex: "wallet_number",
      align: "center",
      render: (wallet_number: string) => (
        <WalletBalanceChecker
          wallet_number={wallet_number}
          company_id={user?.data?.company_id}
        />
      ),
    },

    {
      title: "Actions",
      align: "center",
      render: (record: any) => (
        <div className="flex justify-center items-center gap-2">
          <Link to={`/admin/sheba-pay-wallet/user-role-assign/${record.id}`}>
            <Tooltip title="User Permission">
              <Button
                className="action-button"
                size="small"
                icon={<UserIcon />}
              />
            </Tooltip>
          </Link>

          <Link to={`/admin/sheba-pay-wallet/user-pool-assign/${record.id}`}>
            <Tooltip title="Pool Assign">
              <Button
                className="action-button"
                size="small"
                icon={<AddIcon />}
              />
            </Tooltip>
          </Link>

          <Tooltip title="Edit Wallet">
            <Button
              className="action-button"
              size="small"
              icon={<EditIcon />}
              onClick={() => {
                handleOpen({
                  type: "UPDATE",
                  data: record?.id,
                });
              }}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <>
      <SidebarLayout title="Sheba Pay Wallet" tabList={leaveSettingsTabList}>
        {open?.type === "ADD" || open?.type === "UPDATE" ? (
          <AddWalletModal
            open={open?.open}
            handleClose={handleClose}
            data={open?.data}
            type={open?.type}
          />
        ) : null}

        {paymentStatus === "false" && (
          <Card style={{ width: "100%" }} className="p-5 mb-5">
            <div className="flex items-center justify-center">
              <div className="p-7 bg-[#FFF1EB] rounded-full w-[120px] h-[120px] flex items-center justify-center">
                <InsideWalletIcon />
              </div>
            </div>

            <div className="text-center justify-start text-zinc-700 text-xl font-normal mt-5">
              Your Sheba Wallet account is currently unlinked from this business
              portal. <br /> Kindly link or sync your account to proceed
            </div>

            <div className="flex items-center justify-center mt-5">
              <Link to="/admin/sheba-pay-wallet/sheba-fintech/merchant">
                <Button className="middle-button" type="primary">
                  ShebaPay Authentication
                </Button>
              </Link>
            </div>
          </Card>
        )}

        {/* <div className="flex justify-between items-center mb-5">
          <div className="justify-start text-neutral-700 text-xl font-semibold">
            Sheba Pay Wallet
          </div>

          <div>
            <Button
              icon={<AddIcon />}
              onClick={() => handleOpen({ type: "ADD" })}
              className="mt-2"
              type="primary"
              size="small"
            >
              New Wallet
            </Button>
          </div>
        </div> */}

        {/* {paymentStatus === "true" && (
          <>
            <Card style={{ width: "100%", marginBottom: "25px" }}>
              {isCompanyDetailsLoading ? (
                <Loader />
              ) : user?.data?.company_id &&
                (roleCheck === "Admin" ||
                  roleCheck === "Approver" ||
                  roleCheck === "Maker" ||
                  roleCheck === "Checker" ||
                  role === "SUPER_ADMIN" ||
                  isAdmin) ? (
                <>
                  <div className="flex justify-between items-center">
                    <div className="flex justify-start items-center gap-2">
                      <img
                        src={companyDetails?.data?.logo || AvatarImage}
                        alt=""
                        className="w-14 h-14 rounded-full"
                      />
                      <div className="ml-2">
                        <div className="text-blue-500 text-lg font-semibold leading-normal mb-0.5">
                          {companyDetails?.data?.company_name}
                        </div>
                        {companyDetails?.data?.wallet_number ? (
                          <p className="text-blue-500 text-sm font-medium leading-tight flex items-center gap-3">
                            <span>
                              Wallet No:{" "}
                              {companyDetails?.data?.wallet_number || "N/A"}{" "}
                            </span>
                            {roleCheck === "Admin" ||
                            roleCheck === "Approver" ||
                            role === "SUPER_ADMIN" ||
                            isAdmin ? (
                              <span
                                className="cursor-pointer"
                                onClick={() => handleOpen({ type: "UPDATE" })}
                              >
                                <EditIcon />
                              </span>
                            ) : null}
                          </p>
                        ) : roleCheck === "Admin" ||
                          roleCheck === "Approver" ||
                          role === "SUPER_ADMIN" ||
                          isAdmin ? (
                          <Button
                            icon={<AddIcon />}
                            onClick={() => handleOpen({ type: "ADD" })}
                            className="mt-2"
                            type="primary"
                            size="small"
                          >
                            New Wallet
                          </Button>
                        ) : null}
                      </div>
                    </div>

                    {isBalanceCheckLoading ? (
                      <Spin />
                    ) : user?.data?.company_id ? (
                      <BalanceSlide>
                        {addCommaInNumber(
                          Math.round(balanceCheck?.data?.data?.Amount || 0)
                        )}
                        BDT
                      </BalanceSlide>
                    ) : null}
                  </div>
                </>
              ) : null}
              
              {roleCheck === "Maker" || roleCheck === "Checker" ? (
                <div className="mb-3  flex justify-end">
                  {isBalanceCheckLoading ? (
                    <Spin />
                  ) : user?.data?.company_id ? (
                    <BalanceSlide>
                      {addCommaInNumber(
                        Math.round(balanceCheck?.data?.data?.Amount || 0)
                      )}
                      BDT
                    </BalanceSlide>
                  ) : null}
                </div>
              ) : null}

              <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-5 gap-4">
                {paymentData.map((data, index) => (
                  <Link
                    key={index}
                    to={data.link}
                    className="bg-white rounded-md inline-flex flex-col justify-center items-center gap-3 p-2 py-6 border border-[#e3e6ec]"
                  >
                    <div>{data.icon}</div>
                    <p className="self-stretch text-center justify-center text-slate-600 text-base font-semibold font-['Inter']">
                      {data.title}
                    </p>
                  </Link>
                ))}
              </div>
            </Card>

            <CustomTable
              tableTitle="Recent Transaction History"
              tableTitleButtonName="See All"
              loading={false}
              limit={limit}
              page={page}
              columns={columns}
              total={100}
              dataSource={addKeyInArray(data)}
              handleLimit={handleLimit}
              handlePagination={handlePagination}
              // handleTitleButton={handleTitleButton}
              filterSection={
                <>
                  <Input
                    suffix={<SearchIcon />}
                    placeholder="Search by Name, Id"
                  />

                  <Select
                    // defaultValue="lucy"
                    className="w-[100px]"
                    allowClear
                    suffixIcon={<SelectDownIcon />}
                    options={[
                      { value: "all", label: "All" },
                      { value: "Inactive", label: "Inactive" },
                      { value: "Review", label: "Review" },
                      { value: "Trial", label: "Trial" },
                    ]}
                    placeholder="All"
                  />
                </>
              }
            />
          </>
        )} */}

        {/* {paymentStatus === "true" && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 items-stretch">
            <div className="p-2.5 bg-white rounded-md flex flex-col justify-between items-start gap-3 border border-[#e3e6ec]">
              <div className="flex flex-col justify-between items-start gap-3 w-full">
                <div className="flex justify-between items-center w-full">
                  <div className="flex justify-start items-center gap-2">
                    <div className="">
                      <div className="text-blue-500 text-lg font-semibold leading-normal mb-0.5">
                        {companyDetails?.data?.company_name}
                      </div>
                      <p className="text-blue-500 text-sm font-medium leading-tight flex items-center gap-3">
                        <span>
                          {companyDetails?.data?.wallet_number || "N/A"}{" "}
                        </span>
                        {roleCheck === "Admin" ||
                        roleCheck === "Approver" ||
                        role === "SUPER_ADMIN" ||
                        isAdmin ? (
                          <span
                            className="cursor-pointer"
                            onClick={() => handleOpen({ type: "UPDATE" })}
                          >
                            <EditIcon />
                          </span>
                        ) : null}
                      </p>
                    </div>
                  </div>

                  <div>
                    {isBalanceCheckLoading ? (
                      <Spin />
                    ) : user?.data?.company_id ? (
                      <BalanceSlide>
                        {addCommaInNumber(
                          Math.round(balanceCheck?.data?.data?.Amount || 0)
                        )}
                        BDT
                      </BalanceSlide>
                    ) : null}
                  </div>
                </div>

                <div className="self-stretch h-0 outline-dashed outline-1 outline-offset-[-0.50px] outline-zinc-200 w-full"></div>
              </div>

              <div className="flex flex-wrap justify-start items-center gap-3">
                <div className="px-2 py-0.5 bg-slate-100 rounded-md inline-flex justify-start items-center gap-1.5">
                  <div className="justify-start text-slate-700 text-xs font-normal">
                    Content Creation
                  </div>
                </div>

                <div className="px-2 py-0.5 bg-slate-100 rounded-md inline-flex justify-start items-center gap-1.5">
                  <div className="justify-start text-slate-700 text-xs font-normal">
                    Development
                  </div>
                </div>

                <div className="px-2 py-0.5 bg-slate-100 rounded-md inline-flex justify-start items-center gap-1.5">
                  <div className="justify-start text-slate-700 text-xs font-normal">
                    Product Management
                  </div>
                </div>

                <div className="px-2 py-0.5 bg-slate-100 rounded-md inline-flex justify-start items-center gap-1.5">
                  <div className="justify-start text-slate-700 text-xs font-normal">
                    Recruitment
                  </div>
                </div>

                <div className="px-2 py-0.5 bg-slate-100 rounded-md inline-flex justify-start items-center gap-1.5">
                  <div className="justify-start text-slate-700 text-xs font-normal">
                    Accounting
                  </div>
                </div>
              </div>
            </div>
          </div>
        )} */}

        <CustomTable
          loading={getAllWalletIsLoading}
          limit={limit}
          page={page}
          columns={columns}
          total={getAllWalletData?.data?.totalLength}
          dataSource={addKeyInArray(getAllWalletData?.data?.wallets || [])}
          handleLimit={handleLimit}
          handlePagination={handlePagination}
          filterSection={
            <>
              <Input
                suffix={<SearchIcon />}
                placeholder="Search Wallet Name or Number"
                style={{ width: 280 }}
                allowClear
                onChange={handleSearch}
              />

              <Button
                icon={<AddIcon />}
                onClick={() => handleOpen({ type: "ADD" })}
                className=""
                type="primary"
                size="small"
              >
                New Wallet
              </Button>
            </>
          }
        />
      </SidebarLayout>
    </>
  );
}
